import axiosInstance from '@/utils/axiosInstance.js'
import SERVICE from '@/utils/servicesUtil.js'

const getBalances = ($organizationId) => axiosInstance.get(`${SERVICE.BALANCES}/${$organizationId}`)
const validatebillinginfo = ($organizationId, $data) => axiosInstance.get(`${SERVICE.BALANCE_PAYMENT}/${$organizationId}/validatebillinginfo`, $data)
const validateVoucher = (data) => axiosInstance.post(`${SERVICE.BALANCE_PROMOTION}/validatepromocode`, data)
const getPlansInfo = ($planId) => axiosInstance.get(`${SERVICE.BALANCE_PLAN}/${$planId}/info`)
const postPlansInfo = ($organizationId, data) => axiosInstance.post(`${SERVICE.BALANCE_PLAN}/${$organizationId}/information`, data)
const approveOrganization = ($organizationId) => axiosInstance.post(`${SERVICE.BALANCE_PLAN}/${$organizationId}/approve`)

//  CONTACT
const postSalesManagerContact = ($organizationId, $body) =>
  axiosInstance.post(`${SERVICE.BALANCE_CONTACT}/${$organizationId}/organizationsalesmanager`, $body)

export default {
  getBalances,
  validatebillinginfo,
  validateVoucher,
  getPlansInfo,
  postSalesManagerContact,
  postPlansInfo,
  approveOrganization,
}
